const feeRows = [
  { months: "1 month", price: "$65" },
  { months: "3 months", price: "$150" },
  { months: "12 months", price: "$349" },
];

export function FeesAndPricing() {
  return (
    <div className="section-shell pricing-section">
      <div className="section-grid">
        <section className="section-column" id="pricing" tabIndex={-1} aria-labelledby="pricing-title">
          <span className="eyebrow">Keep it simple</span>
          <h2 className="section-title" id="pricing-title">PRICING</h2>
          <p className="membership-promise">
            <span>NO JOINING FEES - NO CONTRACTS</span>{" "}
            <span>CANCEL AT ANYTIME</span>
          </p>
          <p className="body-copy access-note">
            If you wish to use the gym outside of staffed hours you must purchase
            a 24-hour access card for a once off payment of $15.
          </p>
        </section>
        <section className="section-column" aria-labelledby="fees-title">
          <span className="eyebrow">Your membership options</span>
          <h2 className="section-title" id="fees-title">FEES</h2>
          <div className="fee-options">
            <div className="fee-option">
              <h3>Upfront</h3>
              <table className="fees-table" aria-label="Upfront fees">
                <tbody>
                  {feeRows.map(({ months, price }) => (
                    <tr key={months}>
                      <th scope="row">{months}</th>
                      <td>{price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="fee-option direct-debit">
              <h3>Direct Debit</h3>
              <p className="direct-debit-price">
                Direct debit from{" "}
                <span className="weekly-price">$13 <small>a week</small></span>
              </p>
              <p className="billing-note">Can be debited weekly, fortnightly or monthly.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
